import { useEffect } from 'react'
import type { Driver, Config } from 'driver.js'
import { getDriver } from '@/utils/driver/driverSingleton'
import { useTranslation } from 'react-i18next'
import { renderPopoverFooter } from '@/utils/driver/renderPopoverFooter'

export const createAgentBrokerDriverConfig = (
    t: (key: string) => string
): Partial<Config> => ({
    stagePadding: 0,
    stageRadius: 8,
    popoverOffset: 4,
    popoverClass: 'agent-wizard-popover',
    overlayOpacity: 0.4,
    allowClose: false,
    showProgress: true,
    progressText: ' ',
    showButtons: ['previous', 'next', 'close'],
    doneBtnText: t('agent_wizard.dismiss'),
    onPopoverRender: (popover, opts) => {
        popover.closeButton.replaceChildren()

        // Override config with translated dismiss text
        const config = {
            ...opts.driver.getConfig(),
            closeBtnText: t('agent_wizard.dismiss'),
        }

        // Render footer with buttons using shared utility
        renderPopoverFooter({ popover, opts, config })
    },
    onHighlighted: (element, _step, _opts) => {
        if (!element) {
            return
        }

        const tapTarget = document.createElement('div')
        tapTarget.classList.add('tap-target')

        const tapTargetFade = document.createElement('div')
        tapTargetFade.classList.add('tap-target-fade')

        const tapTargetCircle = document.createElement('div')
        tapTargetCircle.classList.add('tap-target-circle')

        tapTarget.appendChild(tapTargetFade)
        tapTarget.appendChild(tapTargetCircle)

        element.classList.add('is-highlighted')
        element.appendChild(tapTarget)
    },
    onDeselected: (element, _step, _opts) => {
        if (!element) {
            return
        }

        element.classList.remove('is-highlighted')
        const tapTarget = element.querySelector('.tap-target')
        tapTarget?.remove()
    },
})

export const useAgentBrokerDriverConfig = (): Driver => {
    const driver = getDriver()
    const { t } = useTranslation('translations')

    useEffect(() => {
        // Configure driver for agent/broker wizard
        driver.setConfig(createAgentBrokerDriverConfig(t))
    }, [driver, t])

    return driver
}
